import { createConsumer } from "@rails/actioncable"

// Action Cable multiplexes every subscription over one WebSocket. Keeping the
// consumer at module scope prevents each Stimulus controller (and each feed card)
// from opening its own connection as infinite scroll adds content.
const consumer = createConsumer()

export default consumer
